var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarChairIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 11.875L15.125 1C15.125 1 11.1875 1.75 11.1875 3.25C11.1875 4.1875 12.6875 4.75 12.125 5.3125C11.5625 5.875 9.5 6.4375 9.5 7.9375C9.5 8.875 10.115 9.5725 9.5 10.1875C8.9375 10.75 8.375 10.4552 7.4375 10.1875C6.3875 9.8875 4.25 9.625 3.5 9.8125C2.75 10 2 10.375 2 11.5C2 12.1187 2.375 12.8125 3.3125 13C4.25 13.1875 5.375 12.25 6.875 12.25C8.375 12.25 10.25 13.375 11.375 13.375C12.5 13.375 12.875 11.875 12.875 11.875Z",
    fill: "#1C3D5D",
    stroke: "#1C3D5D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13L2.375 16H14.75L12.5 13",
    stroke: "#1C3D5D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarChairIcon);
export default __webpack_public_path__ + "static/media/car-chair-icon.436b542ddc7fa9c47e58daecf9e52a1e.svg";
export { ForwardRef as ReactComponent };